<script setup lang="ts">
  import { vOnClickOutside } from '@vueuse/components'
  import { computed, ref, watch } from 'vue'
  import { useEscListener } from '../modal'

  const props = defineProps<{
    title?: string,
    position?: 'top left' | 'top right' | 'bottom left' | 'bottom right',
  }>()

  const computedPosition = computed(() => {
    return props.position ?? 'bottom right'
  })

  const isOpen = ref(false)
  const close = () => isOpen.value = false
  const onEscape = useEscListener(close)
  watch(isOpen, (value) => {
    if (value) {
      window.addEventListener('keydown', onEscape)
    } else {
      window.removeEventListener('keydown', onEscape)
    }
  })
</script>

<template>
  <div
    v-on-click-outside="close"
    class="relative inline-block">
    <app-button
      class="block"
      :title="title ?? 'Klik untuk menampilkan menu'"
      @click="isOpen = !isOpen">
      <slot></slot>
    </app-button>

    <transition name="scale">
      <div
        v-if="isOpen"
        class="menu-items rounded bg-app"
        :class="{
          'menu-items-right': computedPosition.includes('right'),
          'menu-items-left': computedPosition.includes('left'),
          'menu-items-bottom': computedPosition.includes('bottom'),
          'menu-items-top': computedPosition.includes('top'),
        }"
        @click="isOpen = false">
        <slot name="items"></slot>
      </div>
    </transition>
  </div>
</template>

<style lang="postcss" scoped>
  .menu-items {
    @apply absolute focus:outline-none overflow-hidden text-sm z-10;
    @apply shadow-lg rounded border;
  }
  .menu-items-right {
    @apply right-0;
  }
  .menu-items-left {
    @apply left-0;
  }
  .menu-items-bottom {
    @apply mt-2;
  }
  .menu-items-top {
    @apply bottom-full mb-2;
  }
</style>
